import { render, staticRenderFns } from "./BaseFormViewItem.vue?vue&type=template&id=4a0cd40a&scoped=true"
import script from "./BaseFormViewItem.vue?vue&type=script&lang=js"
export * from "./BaseFormViewItem.vue?vue&type=script&lang=js"
import style0 from "./BaseFormViewItem.vue?vue&type=style&index=0&id=4a0cd40a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a0cd40a",
  null
  
)

export default component.exports